export const saveAppData = async (uid, data) => {
//  const timestamp = new Date().toISOString();
//  await setDoc(doc(db, "users", uid, "cfmResults", timestamp), data);
};

export const fetchAppData = async (uid) => {
  // const snapshot = await getDocs(collection(db, "users", uid, "cfmResults"));
  // return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

};
